import {
  ENV,
  API_URL_DEV,
  API_URL_TEST,
  API_URL_UAT,
  API_URL_PROD,
  WEB_APP_URL_DEV,
  WEB_APP_URL_TEST,
  WEB_APP_URL_UAT,
  WEB_APP_URL_PROD,
} from '@env';

interface ApiConfig {
  currentEnv: string | undefined;
  baseUrls: {
    dev?: string;
    qa?: string;
    uat?: string;
    prod?: string;
  };
  webAppUrls: {
    dev?: string;
    qa?: string;
    uat?: string;
    prod?: string;
  };
  noAuthUrls: {
    demo: string;
    preBooking: string;
    faq: string;
    login: string;
  };
  authUrls: {
    projects: string;
    employees: string;
    projectTeam: string;
    projectDashboard: string;
    backlogs: string;
    employeeDetails: string;
    projectDetails: string;
    userStory: string;
    userStoryDetails: string;
    profile: string;
    resetPasswordOtp: string;
    verifyOtp: string;
    resendOtp: string;
    resetPassword: string;
    setNewPassword: string;
    smartSearch: string;
    validateUserStory: string;
    registerOrganization: string;
    verifyRegisterOrganizationOTP: string;
    resendRegisterOrganizationOTP: string;
  };
}

export const API: ApiConfig = {
  currentEnv: ENV, // API server environment: <dev, qa, uat, prod>
  baseUrls: {
    dev: API_URL_DEV,
    qa: API_URL_TEST,
    uat: API_URL_UAT,
    prod: API_URL_PROD,
  },
  webAppUrls: {
    dev: WEB_APP_URL_DEV,
    qa: WEB_APP_URL_TEST,
    uat: WEB_APP_URL_UAT,
    prod: WEB_APP_URL_PROD,
  },
  noAuthUrls: {
    demo: 'api/v1/demo',
    preBooking: 'api/v1/join-waitlist',
    faq: 'api/v1/faq',
    login: 'api/v1/login-request',
  },
  authUrls: {
    projects: 'api/v1/projects',
    employees: 'api/v1/employee',
    projectTeam: 'api/v1/project/team_member',
    projectDashboard: 'api/v1/project-dashboard',
    backlogs: 'api/v1/backlogs',
    employeeDetails: 'api/v1/employee-details',
    projectDetails: 'api/v1/project-details',
    userStory: 'api/v1/user-story',
    userStoryDetails: 'api/v1/user-story-details',
    profile: 'api/v1/my-profile',
    resetPasswordOtp: 'api/v1/send-reset-password-otp',
    verifyOtp: 'api/v1/verify-reset-password-otp',
    resendOtp: 'api/v1/resend-reset-password-otp',
    resetPassword: 'api/v1/reset-password',
    setNewPassword: 'api/v1/set-new-password',
    smartSearch: 'api/v1/smart-search',
    validateUserStory: 'api/v1/validate-user-story',
    registerOrganization:'api/v1/register-organization',
    verifyRegisterOrganizationOTP:'api/v1/verify-registration-otp',
    resendRegisterOrganizationOTP:'api/v1/resend-registration-otp',
  },
};
